import { render, staticRenderFns } from "./WorkforceLayout.vue?vue&type=template&id=d9f2fd14&"
import script from "./WorkforceLayout.vue?vue&type=script&lang=js&"
export * from "./WorkforceLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports